function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import React from 'react';

var _ref =
/*#__PURE__*/

/*#__PURE__*/
React.createElement("g", {
  transform: "translate(1, 1)"
}, /*#__PURE__*/React.createElement("path", {
  vectorEffect: "non-scaling-stroke",
  className: "st0",
  d: "M42.7,4v-5H12.5v5H-1v69.3h57.2V4H42.7z M17.5,3.9h20.2v5H17.5V3.9z M51.2,68.4H4V9h8.5v4.9h30.2V9h8.5L51.2,68.4L51.2,68.4z"
}), /*#__PURE__*/React.createElement("polygon", {
  vectorEffect: "non-scaling-stroke",
  className: "st0",
  points: "45.6,25.2 49.2,28.8 22.9,55 7.4,39.5 11,35.9 22.9,47.8 \t"
}));

var SvgComponent = function SvgComponent(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    version: 1.1,
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 57.2 74.3",
    fill: "currentColor",
    xmlSpace: "preserve"
  }, props), _ref);
};

export default __webpack_public_path__ + "static/media/ep-sales-results.898640b4.svg";
export { SvgComponent as ReactComponent };